// removed by extract-text-webpack-plugin
module.exports = {"main":"_2dUeF8Bgiow3zoJTtOf2YV"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Fixed.scss
// module id = 691
// module chunks = 12